import axios from '@utils/axios-client'
import { ITag } from 'AppTypes'

export function fetchTags (params: any) {
  return axios.get('/api/v1/tag', { params }).then(response => response.data)
}

export function createTag (data: ITag) {
  return axios.post('/api/vi/tag', data).then(() => true).catch(() => false)
}
